import React, { useEffect, useState } from 'react'
import Select from 'react-select';
import { BuildTalents, getDefaultName, sortByKey } from '../utils'
import { loadCity, loadCountries, loadCourses, loadTalents } from '../utils/Network'
import { getUsersFilterSelectStyles, makeDarkSelectStyles } from './selectStyles';

/** Birth filter: keep country if any localized name mentions Kurdistan (case-insensitive). */
function isKurdistanRegionCountry(item) {
    const names = item?.names;
    if (!names || !names.length) return false;
    return names.some((n) => String(n.name || '').toLowerCase().includes('kurdistan'));
}

export default function SelectCountries({ callback, placeholder, name = "country", value, width , kurds=0, usersFilter, border }) {

    const [SelectOptions, setSelectOptions] = useState([]);
    const customStyles = usersFilter
        ? getUsersFilterSelectStyles({ width: width || '200px', border: 1 })
        : makeDarkSelectStyles({ width: width || '200px', border });


    useEffect(() => {
        loadCountries(1, 1000000).then(countries => {            
            if (countries) {
                sortByKey(countries)
                var temp_options = []
                countries.map((item, i) => {
                    var option = null;
                    option = {
                        label: getDefaultName(item.names),
                        value: item.id
                    }
                    if(kurds)
                    {
                        if (isKurdistanRegionCountry(item))
                            temp_options.push(option)
                    }
                    else
                        temp_options.push(option)
                })
                //
                setSelectOptions(temp_options);
                // callback()
                //setTalents(temp)
            }

        }).catch(() => setSelectOptions([]))
    }, [kurds])

    const handleSelect = (e) => {
        if(e && e.value){
            var value = e.value;
            callback(value, name)
        }
        else{
            callback(null, name)

        }

    }

    return (
        <>
            <div className="filter-select">
                <Select
                    options={SelectOptions}
                    styles={customStyles}
                    isClearable={true}
                    onChange={handleSelect}
                    placeholder={placeholder ? placeholder : "Country"}
                    value={SelectOptions.length ? SelectOptions.find((obj) => String(obj.value) === String(value)) ?? null : null}
                    menuPortalTarget={usersFilter ? document.body : undefined}
                    menuPosition={usersFilter ? 'fixed' : undefined}
                />
            </div>

        </>
    )
}
